export const FEATURED_PRODUCTS_CONTAINER_ELEMENT_ID =
  'featured-products-container';
export const PRODUCT_LIST_ELEMENT_ID = 'product-list';
export const MAX_PRODUCT_DESCRIPTION_LENGTH = 70;
